import { getActiveAnnouncement } from "@/data/selectors";
import { tField } from "@/lib/i18nField";

export default function AnnouncementBar({ lang }) {
  const announcement = getActiveAnnouncement();

  if (!announcement) {
    return null;
  }

  return (
    <aside className="tgwe-announcement" aria-label={tField(announcement.title, lang)}>
      <strong>{tField(announcement.title, lang)}</strong>
      <span>{tField(announcement.message, lang)}</span>
    </aside>
  );
}
